module.exports = "/_next/static/images/1373d7ce692fa622908f12fc23e3c795-payment_where.png.webp";